import { Card, CircularProgress } from "@material-ui/core";
import React, { Component } from "react";
import DiagramDosenTetap from "../../component/Dosen/Widget/DiagramDosenTetap";
import DiagramDosenSertifikasi from "../../component/Dosen/Widget/DiagramDosenSertifikasi";
import DiagramJabFung from "../../component/Dosen/Widget/DiagramJabFung";
import axios from "axios";
import DiagramDosenTidakTetap from "../../component/Dosen/Widget/DiagramDosenTidakTetap";
import AppConfig from "../../../../config/AppConfig";


class DosenPT extends Component {
    state = {
        loading: false,
        DiagramMhsAktif: [],
        DiagramMhsAsingPindahan:[],
        DiagramIkatan: [],
    }
    componentDidMount(){
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if(userdata){
            let id_sms = "";
            if(sessiondata.i_idsms !== undefined){
                id_sms = "&id_sms="+sessiondata.i_idsms
            }
            if(this.props.idSp !== undefined) {
                session = "?id_sp="+this.props.idSp+id_sms
            }else{
                session = "?id_sp="+sessiondata.i_idunit+id_sms
            }
        }
        // let data_mhs        = AppConfig.MhsTerdaftar+session;
        let data_dosen      = AppConfig.DosenIkatan+session;
        let rq_dosen          = axios.get(data_dosen);
        axios.all([
            rq_dosen
          ])
        .then(axios.spread((...responses) => {
            let respon_dosen            = responses[0];
            let data_dosen_ikatan = {
                data_dosen_ikatan : respon_dosen.data.result.dataikatan,
                data_dosen_jabfung : respon_dosen.data.result.datajabfung,
                data_dosen_dosen_sertifikasi : respon_dosen.data.result.dosen_sertifikasi,
                jumdosen : respon_dosen.data.result.jumdosen,
                display: true,
            }
            this.setState({
                DiagramIkatan : data_dosen_ikatan,
                loading: true,
            });
        }))
        .catch(errors => {
        console.log(errors);
        });
    }
    componentDidUpdate(){
        let id_sms = "";
        if(this.props.displayProdi === true){
            id_sms = "&id_sms="+this.props.idSms;

            let userdata = JSON.parse(localStorage.getItem("userdata"));
            let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
            let session = "";
            if(userdata){
                if(this.props.idSp !== undefined) {
                    session = "?id_sp="+this.props.idSp+id_sms
                }else{
                    session = "?id_sp="+sessiondata.i_idunit+id_sms
                }
            }
            // let data_mhs        = AppConfig.MhsTerdaftar+session;
            let data_dosen      = AppConfig.DosenIkatan+session;
            let rq_dosen          = axios.get(data_dosen);
            axios.all([
                rq_dosen
            ])
            .then(axios.spread((...responses) => {
                let respon_dosen            = responses[0];
                let data_dosen_ikatan = {
                    data_dosen_ikatan : respon_dosen.data.result.dataikatan,
                    data_dosen_jabfung : respon_dosen.data.result.datajabfung,
                    data_dosen_dosen_sertifikasi : respon_dosen.data.result.dosen_sertifikasi,
                    jumdosen : respon_dosen.data.result.jumdosen,
                    display: true,
                }
                this.setState({
                    DiagramIkatan : data_dosen_ikatan,
                    loading: true,
                });
                this.props.handleCallbackDisplayProdi(false);
                this.props.handleCallbackSearch(false);
            }))
            .catch(errors => {
            console.log(errors);
            });
        }
        if(this.props.resetProdi === true){
            this.componentDidMount();
            this.props.handleCallbackResetProdi(false);
        }
    }
    render() {
        let {loading} = this.state;
        let display_data = [];
        if(loading === true){
            display_data = 
            <div className="row row-paddingless">
                <div className="col-md-12" style={{textAlign:'center'}}>
                    <Card  style={{margin:"5px"}}>
                        {/* <DiagramIkatanKerja dataDosen={this.state.DiagramIkatan}/> */}
                        <DiagramDosenTetap dataDosen={this.state.DiagramIkatan}/>
                    </Card>
                </div>
                <div className="col-md-12" style={{textAlign:'center'}}>
                    <Card  style={{margin:"5px"}}>
                        <DiagramDosenTidakTetap dataDosen={this.state.DiagramIkatan}/>
                    </Card>
                </div>
                <div className="col-md-6" style={{textAlign:'center'}}>
                    <Card  style={{margin:"5px"}}>
                        <DiagramDosenSertifikasi dataDosen={this.state.DiagramIkatan}/>
                    </Card>
                </div>
                <div className="col-md-6" style={{textAlign:'center'}}>
                    <Card  style={{margin:"5px"}}>
                        <DiagramJabFung dataDosen={this.state.DiagramIkatan}/>
                    </Card>
                </div>
            </div>;
        }else{
            display_data =
            <div style={{width:'100%', marginTop:'10%', textAlign:'center', verticalAlign:'middle'}}>
                <CircularProgress color="secondary" />
            </div>
            ;
        }
        return (display_data)
    }
}
export default DosenPT;